import React from "react";
import "./UserImage.css";

const UserImage = () => {
  return (
    <div className="userImage">
      <img
        src="https://envato-shoebox-0.imgix.net/e545/b1cd-8865-474f-afe8-c257d29173a8/589_T13A9262.jpg?auto=compress%2Cformat&fit=max&mark=https%3A%2F%2Felements-assets.envato.com%2Fstatic%2Fwatermark2.png&markalign=center%2Cmiddle&markalpha=18&w=700&s=7db3c3d1e788b6e9964c6a0a0f41d149"
        className="userImage__img"
      />
    </div>
  );
};

export default UserImage;
